import Footer from "../components/Footer/Footer"
import HeaderMain from "../components/HeaderMain/HeaderMain"

const Home = () => {
  return (
    <div>
        <HeaderMain/>
        <Footer/>
    </div>
  )
}

export default Home